import { render, staticRenderFns } from "./Expiration.vue?vue&type=template&id=2f4dab8e&scoped=true&"
import script from "./Expiration.vue?vue&type=script&lang=js&"
export * from "./Expiration.vue?vue&type=script&lang=js&"
import style0 from "./Expiration.vue?vue&type=style&index=0&id=2f4dab8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4dab8e",
  null
  
)

export default component.exports